import { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import admin from "../assets/admin.png";
import logo from "../assets/logo.png";
import AddNewDropdown from "./AddNewResearch";
import { useProfile } from "../context/ProfileContext";
import useNotifications from "../hooks/useNotifications";
import Notifications from "./notifications/Notifications";
import useMessageList from "../hooks/useMessageList";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const MobileHeader = ({
  hideSearchBar = false,
  hideLogo = false,
  hideHamburger = false,
  hideFilter = false,
  hideBell = false,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [contentType, setContentType] = useState("all");
  const [menuOpen, setMenuOpen] = useState(false);
  const profileRef = useRef(null);
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const [open, setOpen] = useState(false);
  const bellRef = useRef(null);
  const location = useLocation();
  const { profileId, setProfileId, setProfileData } = useProfile();
  const { notifications, unreadCount } = useNotifications();
  const { unreadMap } = useMessageList();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        const data = await res.json();
        if (res.ok) {
          setProfile(data.data);
        } else {
          console.error("Profile fetch failed");
        }
      } catch (error) {
        console.error("Error fetching profile:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setIsProfileDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleClickOutside(e) {
      if (bellRef.current && !bellRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = (id) => {
    setOpenDropdown((prev) => (prev === id ? null : id));
    setIsProfileDropdownOpen(false);
  };

  const toggleProfileDropdown = () => {
    console.log("Profile image clicked");
    setIsProfileDropdownOpen((prev) => !prev);
    setIsDropdownOpen(false);
  };

  const handleLogout = () => {
    console.log("Logout clicked");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/");
  };

  const handleConfirmDelete = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      alert("You are not logged in.");
      return;
    }
    try {
      const response = await fetch(`${BASE_URL}/user/delete-account/`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      if (response.ok) {
        console.error("Account deleted successfully!");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        navigate("/");
      } else {
        const data = await response.json();
        alert(data.message || "Failed to delete account");
      }
    } catch (error) {
      alert("Error deleting account.");
    } finally {
      setShowDeleteModal(false);
    }
  };

  const handleSearch = async (query) => {
    if (!query || !query.trim()) {
      setSearchResults([]);
      return;
    }
    setIsSearching(true);
    setSearchResults([]);
    try {
      const res = await fetch(
        `${BASE_URL}/user/publication/search-data/?title=${encodeURIComponent(
          query
        )}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );
      const data = await res.json();
      console.log(data);
      if (res.ok) {
        const exactMatchResults = (data.results || []).filter((user) =>
          user.name?.toLowerCase().includes(query.toLowerCase())
        );
        setSearchResults(exactMatchResults);
      } else {
        console.error("Search failed");
      }
    } catch (err) {
      console.error("Search error:", err.message);
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("search") || "";
    setSearchTerm(query);
  }, [location.search]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setSearchResults([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleContentFilter = (type) => {
    const params = new URLSearchParams(location.search);
    if (type !== "all") {
      params.set("type", type);
    } else {
      params.delete("type");
    }
    navigate(`/home?${params.toString()}`);
  };

  const totalUnreadMessages = Object.values(unreadMap).reduce(
    (acc, count) => acc + count,
    0
  );

  return (
    // <>
    //   <nav className="navbar-container mobile-header">
    //     <div className="mobile-header-content">
    //       <img
    //         src={logo}
    //         alt="Logo"
    //         className="mobile-logo"
    //         onClick={() => {
    //           const token = localStorage.getItem("access_token");
    //           navigate(token ? "/home" : "/");
    //         }}
    //       />
    //       {!hideSearchBar && profile && (
    //         <div className="mobile-search" ref={searchRef}>
    //           <input
    //             type="text"
    //             placeholder="Search"
    //             value={searchTerm}
    //             onChange={(e) => {
    //               const value = e.target.value;
    //               setSearchTerm(value);
    //               handleSearch(value);

    //               if (location.pathname === "/home") {
    //                 const params = new URLSearchParams(location.search);
    //                 if (value.trim()) {
    //                   params.set("search", value.trim());
    //                 } else {
    //                   params.delete("search");
    //                 }
    //                 navigate(`/home?${params.toString()}`);
    //               }
    //             }}
    //             onKeyDown={(e) => {
    //               if (e.key === "Enter" && location.pathname !== "/home") {
    //                 navigate(`/home?search=${encodeURIComponent(searchTerm)}`);
    //               }
    //             }}
    //           />

    //           {searchTerm.trim() && searchResults.length > 0 && (
    //             <div className="search-dropdown">
    //               <ul>
    //                 {searchResults.map((user) => (
    //                   <li key={user.id}>
    //                     <div
    //                       className="search-result-item"
    //                       onClick={() => {
    //                         setSearchResults([]);
    //                         setProfileId(user.id);
    //                         setProfileData(user);
    //                         console.log("user: ", user.id);

    //                         if (String(user.id) === String(profileId)) {
    //                           navigate("/profile-view", {
    //                             state: {
    //                               isOwnProfile: true,
    //                               profileData: user,
    //                             },
    //                           });
    //                         } else {
    //                           navigate(`/user-profile/${user.id}`, {
    //                             state: {
    //                               isOwnProfile: false,
    //                               profileData: user,
    //                             },
    //                           });
    //                         }
    //                       }}
    //                     >
    //                       <img
    //                         src={user.profile_picture || admin}
    //                         alt={user.name}
    //                         className="search-profile-img"
    //                       />
    //                       {user.name}
    //                     </div>
    //                   </li>
    //                 ))}
    //               </ul>
    //             </div>
    //           )}
    //         </div>
    //       )}
    //       <div className="profile-container" ref={profileRef}>
    //         {!hideBell && profile && (
    //           <>
    //             <div ref={bellRef} style={{ position: "relative" }}>
    //               <button
    //                 onClick={() => setOpen(!open)}
    //                 className="bell-button"
    //               >
    //                 <Bell size={24} stroke="#007bff" />
    //                 {unreadCount > 0 && (
    //                   <span className="notification-badge">{unreadCount}</span>
    //                 )}{" "}
    //               </button>

    //               {open && <Notifications />}
    //             </div>

    //             <div>
    //               <button
    //                 onClick={() => navigate("/chat")}
    //                 className="bell-button"
    //               >
    //                 {" "}
    //                 <MessageCircleDashed size={24} stroke="#007bff" />{" "}
    //                 {totalUnreadMessages > 0 && (
    //                   <span className="notification-badge">
    //                     {totalUnreadMessages}
    //                   </span>
    //                 )}
    //               </button>
    //             </div>
    //           </>
    //         )}
    //         <div className="mobile-right-icons">
    //           {!hideLogo && profile && (
    //             <>
    //               <img
    //                 src={profile?.profile_picture || admin}
    //                 alt="User"
    //                 onClick={toggleProfileDropdown}
    //                 className="mobile-profile-img"
    //               />
    //             </>
    //           )}
    //           {!hideFilter && (
    //             <button
    //               className="hamburger-btn"
    //               onClick={() => setMenuOpen(!menuOpen)}
    //             >
    //               {!hideHamburger && profile && (
    //                 <div className={`hamburger-icon ${menuOpen ? "open" : ""}`}>
    //                   <span className="hamburger-line"></span>
    //                   <span className="hamburger-line"></span>
    //                   <span className="hamburger-line"></span>
    //                 </div>
    //               )}
    //             </button>
    //           )}
    //         </div>

    //         {isProfileDropdownOpen && profile && (
    //           <div className="profile-dropdown">
    //             <ul className="dropdownlist">
    //               <li className="dropdown-items">
    //                 <Link
    //                   to="/profile-view"
    //                   onClick={() => {
    //                     console.log("Profile view clicked");
    //                     setIsProfileDropdownOpen(false);
    //                   }}
    //                 >
    //                   <p className="dropdown-items2">Your profile</p>
    //                 </Link>
    //               </li>
    //               <li className="dropdown-items">
    //                 <Link
    //                   to="/changepassword"
    //                   onClick={() => setIsProfileDropdownOpen(false)}
    //                 >
    //                   <p className="dropdown-items2">Change password</p>
    //                 </Link>
    //               </li>
    //               <li
    //                 className="dropdown-items"
    //                 onClick={() => {
    //                   setIsProfileDropdownOpen(false);
    //                   setShowDeleteModal(true);
    //                 }}
    //               >
    //                 <p className="dropdown-items2">Delete Account</p>
    //               </li>
    //               <li
    //                 className="dropdown-items logout"
    //                 onClick={() => {
    //                   setIsProfileDropdownOpen(false);
    //                   handleLogout();
    //                 }}
    //               >
    //                 <p className="dropdown-items2">Log out</p>
    //               </li>
    //             </ul>
    //           </div>
    //         )}
    //       </div>
    //     </div>
    //     <div className="for_mobile_searchbar">
    //       {!hideSearchBar && profile && (
    //         <div className="mobile-search">
    //           <input
    //             type="text"
    //             placeholder="Search"
    //             value={searchTerm}
    //             onChange={(e) => {
    //               const value = e.target.value;
    //               setSearchTerm(value);
    //               handleSearch(value);

    //               if (location.pathname === "/home") {
    //                 const params = new URLSearchParams(location.search);
    //                 if (value.trim()) {
    //                   params.set("search", value.trim());
    //                 } else {
    //                   params.delete("search");
    //                 }
    //                 navigate(`/home?${params.toString()}`);
    //               }
    //             }}
    //             onKeyDown={(e) => {
    //               if (e.key === "Enter" && location.pathname !== "/home") {
    //                 navigate(`/home?search=${encodeURIComponent(searchTerm)}`);
    //               }
    //             }}
    //           />
    //           {isSearching && (
    //             <div className="search-loading">Searching...</div>
    //           )}

    //           {searchTerm.trim() && searchResults.length > 0 && (
    //             <div className="search-dropdown">
    //               <ul>
    //                 {searchResults.map((user) => (
    //                   <li key={user.id}>
    //                     <div
    //                       className="search-result-item"
    //                       onClick={() => {
    //                         setSearchResults([]);
    //                         setProfileId(user.id);
    //                         setProfileData(user);
    //                         console.log("user: ", user.id);

    //                         if (String(user.id) === String(profileId)) {
    //                           navigate("/profile-view", {
    //                             state: {
    //                               isOwnProfile: true,
    //                               profileData: user,
    //                             },
    //                           });
    //                         } else {
    //                           navigate(`/user-profile/${user.id}`, {
    //                             state: {
    //                               isOwnProfile: false,
    //                               profileData: user,
    //                             },
    //                           });
    //                         }
    //                       }}
    //                     >
    //                       <img
    //                         src={user.profile_picture || admin}
    //                         alt={user.name}
    //                         className="search-profile-img"
    //                       />
    //                       {user.name}
    //                     </div>
    //                   </li>
    //                 ))}
    //               </ul>
    //             </div>
    //           )}
    //         </div>
    //       )}
    //     </div>

    //     {menuOpen && (
    //       <div className="mobile-menu">
    //         <Link to="/home" onClick={() => setMenuOpen(false)}>
    //           Home
    //         </Link>
    //         <div className="content-filter mobile-content-tabs">
    //           {["all", "publication", "video", "image", "code", "job", "post"].map((type) => {
    //             const currentType =
    //               new URLSearchParams(location.search).get("type") || "all";
    //             return (
    //               <button
    //                 key={type}
    //                 onClick={() => handleContentFilter(type)}
    //                 className={`filter-btn ${currentType === type ? "active" : ""}`}
    //               >
    //                 {type === "all"
    //                   ? "All"
    //                   : type.charAt(0).toUpperCase() + type.slice(1) + (type === "video" ? "s" : "")}
    //               </button>
    //             );
    //           })}
    //         </div>


    //         <AddNewDropdown
    //           isOpen={openDropdown === "btn1"}
    //           onClose={() => setOpenDropdown(null)}
    //         />
    //       </div>
    //     )}
    //   </nav>

    //   {showDeleteModal && (
    //     <div className="delete-modal-overlay">
    //       <div className="delete-modal">
    //         <h3>Are you sure you want to delete your account?</h3>
    //         <p>This action cannot be undone.</p>
    //         <div className="modal-actions">
    //           <button className="confirm-btn" onClick={handleConfirmDelete}>
    //             Confirm
    //           </button>
    //           <button
    //             className="cancel-btn"
    //             onClick={() => setShowDeleteModal(false)}
    //           >
    //             Cancel
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )}
    // </>
  <>
  <nav className="block md:hidden w-full flex flex-col items-center sticky top-0 z-50 p-3 border-b border-gray-200 bg-white shadow-sm">
    <div className="flex items-center justify-between gap-3 w-full">
      {/* Logo */}
      <img
        src={logo}
        alt="Logo"
        className="h-auto w-28 min-w-[120px] cursor-pointer"
        onClick={() => {
          const token = localStorage.getItem("access_token");
          navigate(token ? "/home" : "/");
        }}
      />
    
      {/* Right Side Actions */}
      <div className="flex gap-2 relative" ref={profileRef}>
        {!hideBell && profile && (
          <>
            <div ref={bellRef} className="relative">
              <button
                onClick={() => setOpen(!open)}
                className="relative w-10 h-10 bg-[#e8f0f7] flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
              >
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
                {unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-semibold w-5 h-5 flex items-center justify-center rounded-full">
                    {unreadCount}
                  </span>
                )}
              </button>

              {open && <Notifications />}
            </div>

            <div>
              <button
                onClick={() => navigate("/chat")}
                className="relative w-10 h-10 bg-[#e8f0f7] flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
              >
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                {totalUnreadMessages > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-semibold w-5 h-5 flex items-center justify-center rounded-full">
                    {totalUnreadMessages}
                  </span>
                )}
              </button>
            </div>
          </>
        )}
        
        <div className="flex items-center gap-2">
          {!hideLogo && profile && (
            <>
              <img
                src={profile?.profile_picture || admin}
                alt="User"
                onClick={toggleProfileDropdown}
                className="w-10 h-10  object-cover rounded-full border border-gray-100 cursor-pointer"
              />
            </>
          )}
          {!hideFilter && (
            <button
              className="w-10 h-10 flex items-center text-gray-600 justify-center rounded-xl bg-gray-100 hover:bg-gray-150 transition-colors"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {!hideHamburger && profile && (
                <div className="flex flex-col gap-1">
                  <span className={`w-5 h-0.5 bg-gray-600 rounded-full transition-transform ${menuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
                  <span className={`w-5 h-0.5 bg-gray-600 rounded-full transition-opacity ${menuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
                  <span className={`w-5 h-0.5 bg-gray-600 rounded-full transition-transform ${menuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
                </div>
              )}
            </button>
          )}
        </div>

        {/* Profile Dropdown */}
        {isProfileDropdownOpen && profile && (
          <div className="absolute top-12 right-0 bg-white rounded-xl shadow-lg border border-gray-200 w-56 py-2 z-50">
            <div className="p-1">
              <Link
                to="/profile-view"
                className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
                onClick={() => {
                  console.log("Profile view clicked");
                  setIsProfileDropdownOpen(false);
                }}
              >
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span className="text-sm font-medium">Your Profile</span>
              </Link>
              
              <Link
                to="/changepassword"
                className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
                onClick={() => setIsProfileDropdownOpen(false)}
              >
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
                <span className="text-sm font-medium">Change Password</span>
              </Link>
              
              <div
                className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-red-50 transition-colors text-red-500 cursor-pointer"
                onClick={() => {
                  setIsProfileDropdownOpen(false);
                  setShowDeleteModal(true);
                }}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                <span className="text-sm font-medium">Delete Account</span>
              </div>
              
              <div className="border-t border-gray-200 mt-1 pt-1">
                <div
                  className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer"
                  onClick={() => {
                    setIsProfileDropdownOpen(false);
                    handleLogout();
                  }}
                >
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  <span className="text-sm font-medium">Log out</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    
    {/* Search Bar */}
    <div className="w-full mt-3">
      {!hideSearchBar && profile && (
        <div className="relative">
          <div className="flex items-center bg-white px-4 py-2.5 rounded-xl border border-gray-300">
            <svg className="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              placeholder="Search for research, people, etc."
              className="flex-grow border-none bg-transparent outline-none text-sm placeholder-gray-400"
              value={searchTerm}
              onChange={(e) => {
                const value = e.target.value;
                setSearchTerm(value);
                handleSearch(value);

                if (location.pathname === "/home") {
                  const params = new URLSearchParams(location.search);
                  if (value.trim()) {
                    params.set("search", value.trim());
                  } else {
                    params.delete("search");
                  }
                  navigate(`/home?${params.toString()}`);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && location.pathname !== "/home") {
                  navigate(`/home?search=${encodeURIComponent(searchTerm)}`);
                }
              }}
            />
          </div>
          
          {isSearching && (
            <div className="mt-2 text-sm text-gray-500 flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
              Searching...
            </div>
          )}

          {searchTerm.trim() && searchResults.length > 0 && (
            <div className="absolute top-full mt-2 left-0 right-0 bg-white rounded-xl shadow-lg border border-gray-200 max-h-64 overflow-y-auto z-20">
              <div className="p-2">
                {searchResults.map((user) => (
                  <div
                    key={user.id}
                    className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                    onClick={() => {
                      setSearchResults([]);
                      setProfileId(user.id);
                      setProfileData(user);
                      console.log("user: ", user.id);

                      if (String(user.id) === String(profileId)) {
                        navigate("/profile-view", {
                          state: {
                            isOwnProfile: true,
                            profileData: user,
                          },
                        });
                      } else {
                        navigate(`/user-profile/${user.id}`, {
                          state: {
                            isOwnProfile: false,
                            profileData: user,
                          },
                        });
                      }
                    }}
                  >
                    <img
                      src={user.profile_picture || admin}
                      alt={user.name}
                      className="w-10 h-10 rounded-lg object-cover border border-gray-200"
                    />
                    <div>
                      <p className="font-medium text-gray-900 text-sm">{user.name}</p>
                      <p className="text-xs text-gray-500">View profile</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>

    {/* Filter Menu */}
    {menuOpen && (
      <div className="w-full mt-3 bg-white rounded-xl border border-gray-200 shadow-sm p-4">
        <div className="mb-4">
          <Link 
            to="/home" 
            onClick={() => setMenuOpen(false)}
            className="flex items-center gap-2 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700 font-medium"
          >
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Home
          </Link>
        </div>
        
        <div className="mb-4">
          <p className="text-xs text-gray-500 uppercase font-semibold mb-2 px-2">Filter by Type</p>
          <div className="flex flex-wrap gap-2">
            {["all", "publication", "video", "image", "code", "job", "post"].map((type) => {
              const currentType =
                new URLSearchParams(location.search).get("type") || "all";
              return (
                <button
                  key={type}
                  onClick={() => handleContentFilter(type)}
                  className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                    currentType === type 
                      ? "bg-[#0f6abf] text-white" 
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {type === "all"
                    ? "All"
                    : type.charAt(0).toUpperCase() + type.slice(1) + (type === "video" ? "s" : "")}
                </button>
              );
            })}
          </div>
        </div>

        <AddNewDropdown
          isOpen={openDropdown === "btn1"}
          onClose={() => setOpenDropdown(null)}
        />
      </div>
    )}
  </nav>

  {/* Delete Account Modal */}
  {showDeleteModal && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4">
      <div className="bg-white p-6 rounded-2xl w-full max-w-sm text-center shadow-xl">
        <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Delete Your Account?</h3>
        <p className="text-gray-600 text-sm mb-6">This action cannot be undone. All your data will be permanently removed.</p>
        <div className="flex gap-3">
          <button
            className="flex-1 px-4 py-2.5 bg-gray-100 text-gray-700 font-medium rounded-xl hover:bg-gray-200 transition-colors text-sm"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            className="flex-1 px-4 py-2.5 bg-red-500 text-white font-medium rounded-xl hover:bg-red-600 transition-colors text-sm"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  )}
</>
//     <>
//   <nav className="block md:hidden w-full h-full flex items-center justify-center transition-all duration-300 backdrop-blur-md sticky top-0 z-[999] flex-col px-4 py-2.5 bg-[var(--topbar-blur-bg)] border-b-2 border-[var(--topbar-border-color)]">
//     <div className="w-full flex items-center justify-between gap-5">
//       <img
//         src={logo}
//         alt="Logo"
//         className="w-20 h-auto cursor-pointer min-w-[80px] max-w-[80px]"
//         onClick={() => {
//           const token = localStorage.getItem("access_token");
//           navigate(token ? "/home" : "/");
//         }}
//       />
//       {!hideSearchBar && profile && (
//         <div className="flex-grow mx-0 sm:mx-8 relative" ref={searchRef}>
//           <div className="flex items-center bg-white px-3 py-2 rounded-[20px] border border-[#797979]">
//             <input
//               type="text"
//               placeholder="Search"
//               className="flex-grow border-none bg-transparent outline-none text-sm w-full"
//               value={searchTerm}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 setSearchTerm(value);
//                 handleSearch(value);

//                 if (location.pathname === "/home") {
//                   const params = new URLSearchParams(location.search);
//                   if (value.trim()) {
//                     params.set("search", value.trim());
//                   } else {
//                     params.delete("search");
//                   }
//                   navigate(`/home?${params.toString()}`);
//                 }
//               }}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter" && location.pathname !== "/home") {
//                   navigate(`/home?search=${encodeURIComponent(searchTerm)}`);
//                 }
//               }}
//             />
//           </div>

//           {searchTerm.trim() && searchResults.length > 0 && (
//             <div className="absolute top-12 left-1/4 right-1/4 bg-[var(--topbar-blur-bg)] text-[var(--text-primary)] border border-[#797979] rounded-lg max-h-[250px] overflow-y-auto z-20">
//               <ul className="m-0 p-2 list-none">
//                 {searchResults.map((user) => (
//                   <li key={user.id} className="p-2">
//                     <div
//                       className="flex items-center gap-2 text-sm cursor-pointer hover:bg-[var(--surface-center)] p-2 rounded"
//                       onClick={() => {
//                         setSearchResults([]);
//                         setProfileId(user.id);
//                         setProfileData(user);
//                         console.log("user: ", user.id);

//                         if (String(user.id) === String(profileId)) {
//                           navigate("/profile-view", {
//                             state: {
//                               isOwnProfile: true,
//                               profileData: user,
//                             },
//                           });
//                         } else {
//                           navigate(`/user-profile/${user.id}`, {
//                             state: {
//                               isOwnProfile: false,
//                               profileData: user,
//                             },
//                           });
//                         }
//                       }}
//                     >
//                       <img
//                         src={user.profile_picture || admin}
//                         alt={user.name}
//                         className="w-9 h-9 rounded-full object-cover"
//                       />
//                       {user.name}
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//       )}
//       <div className="flex items-center gap-2.5" ref={profileRef}>
//         {!hideBell && profile && (
//           <>
//             <div style={{ position: "relative" }} ref={bellRef}>
//               <button
//                 onClick={() => setOpen(!open)}
//                 className="relative text-white border border-transparent cursor-pointer p-1.5 transition-transform duration-200 ease-in-out hover:scale-110 focus:outline-none focus:border-none focus:ring-0"
//               >
//                 <Bell size={24} stroke="#007bff" />
//                 {unreadCount > 0 && (
//                   <span className="absolute -top-1 -right-1 bg-[var(--surface-panel)] text-[var(--text-primary)] text-[10px] font-semibold px-1.5 py-0.5 rounded-full animate-pop">
//                     {unreadCount}
//                   </span>
//                 )}
//               </button>

//               {open && <Notifications />}
//             </div>

//             <div>
//               <button
//                 onClick={() => navigate("/chat")}
//                 className="relative text-white border border-transparent cursor-pointer p-1.5 transition-transform duration-200 ease-in-out hover:scale-110 focus:outline-none focus:border-none focus:ring-0"
//               >
//                 <MessageCircleDashed size={24} stroke="#007bff" />
//                 {totalUnreadMessages > 0 && (
//                   <span className="absolute -top-1 -right-1 bg-[var(--surface-panel)] text-[var(--text-primary)] text-[10px] font-semibold px-1.5 py-0.5 rounded-full animate-pop">
//                     {totalUnreadMessages}
//                   </span>
//                 )}
//               </button>
//             </div>
//           </>
//         )}
//         <div className="flex items-center gap-5 cursor-pointer">
//           {!hideLogo && profile && (
//             <>
//               <img
//                 src={profile?.profile_picture || admin}
//                 alt="User"
//                 onClick={toggleProfileDropdown}
//                 className="w-9 h-9 object-cover rounded-full border border-gray-300"
//               />
//             </>
//           )}
//           {!hideFilter && (
//             <button
//               className="border-none bg-none"
//               onClick={() => setMenuOpen(!menuOpen)}
//             >
//               {!hideHamburger && profile && (
//                 <div className={`flex flex-col justify-center gap-1.5 cursor-pointer ${menuOpen ? "open" : ""}`}>
//                   <span className="w-6 h-0.5 bg-gray-800 rounded transition-all duration-300"></span>
//                   <span className="w-6 h-0.5 bg-gray-800 rounded transition-all duration-300"></span>
//                   <span className="w-6 h-0.5 bg-gray-800 rounded transition-all duration-300"></span>
//                 </div>
//               )}
//             </button>
//           )}
//         </div>

//         {isProfileDropdownOpen && profile && (
//           <div className="absolute top-14 right-4 bg-white text-[var(--text-primary)] rounded-xl w-60 p-1.5 backdrop-blur-lg z-[1000]">
//             <ul className="list-none p-1 m-0">
//               <li className="cursor-pointer text-[var(--text-primary)] transition-colors duration-200 ease-in-out hover:bg-[var(--accent-blue-bg)]">
//                 <Link
//                   to="/profile-view"
//                   onClick={() => {
//                     console.log("Profile view clicked");
//                     setIsProfileDropdownOpen(false);
//                   }}
//                   className="text-[14px]"
//                 >
//                   <p className="px-5 py-3">Your profile</p>
//                 </Link>
//               </li>
//               <li className="cursor-pointer text-[var(--text-primary)] transition-colors duration-200 ease-in-out hover:bg-[var(--accent-blue-bg)]">
//                 <Link
//                   to="/changepassword"
//                   onClick={() => setIsProfileDropdownOpen(false)}
//                   className="text-[14px]"
//                 >
//                   <p className="px-5 py-3">Change password</p>
//                 </Link>
//               </li>
//               <li
//                 className="cursor-pointer text-[var(--text-primary)] transition-colors duration-200 ease-in-out hover:bg-[var(--accent-blue-bg)]"
//                 onClick={() => {
//                   setIsProfileDropdownOpen(false);
//                   setShowDeleteModal(true);
//                 }}
//               >
//                 <p className="px-5 py-3">Delete Account</p>
//               </li>
//               <li
//                 className="cursor-pointer text-[var(--text-primary)] font-semibold transition-colors duration-200 ease-in-out hover:bg-[var(--accent-blue-bg)] border-t border-[#e0e0e0] mt-1.5"
//                 onClick={() => {
//                   setIsProfileDropdownOpen(false);
//                   handleLogout();
//                 }}
//               >
//                 <p className="px-5 py-3">Log out</p>
//               </li>
//             </ul>
//           </div>
//         )}
//       </div>
//     </div>
//     <div className="hidden max-[430px]:block w-full">
//       {!hideSearchBar && profile && (
//         <div className="w-full mt-2">
//           <div className="flex items-center bg-white px-3 py-2 rounded-[20px] border border-[#797979] w-full">
//             <input
//               type="text"
//               placeholder="Search"
//               className="flex-grow border-none bg-transparent outline-none text-sm w-full"
//               value={searchTerm}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 setSearchTerm(value);
//                 handleSearch(value);

//                 if (location.pathname === "/home") {
//                   const params = new URLSearchParams(location.search);
//                   if (value.trim()) {
//                     params.set("search", value.trim());
//                   } else {
//                     params.delete("search");
//                   }
//                   navigate(`/home?${params.toString()}`);
//                 }
//               }}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter" && location.pathname !== "/home") {
//                   navigate(`/home?search=${encodeURIComponent(searchTerm)}`);
//                 }
//               }}
//             />
//           </div>
//           {isSearching && (
//             <div className="mt-1 text-sm text-gray-500">Searching...</div>
//           )}

//           {searchTerm.trim() && searchResults.length > 0 && (
//             <div className="absolute left-4 right-4 bg-[var(--topbar-blur-bg)] text-[var(--text-primary)] border border-[#797979] rounded-lg max-h-[250px] overflow-y-auto z-20 mt-1">
//               <ul className="m-0 p-2 list-none">
//                 {searchResults.map((user) => (
//                   <li key={user.id} className="p-2">
//                     <div
//                       className="flex items-center gap-2 text-sm cursor-pointer hover:bg-[var(--surface-center)] p-2 rounded"
//                       onClick={() => {
//                         setSearchResults([]);
//                         setProfileId(user.id);
//                         setProfileData(user);
//                         console.log("user: ", user.id);

//                         if (String(user.id) === String(profileId)) {
//                           navigate("/profile-view", {
//                             state: {
//                               isOwnProfile: true,
//                               profileData: user,
//                             },
//                           });
//                         } else {
//                           navigate(`/user-profile/${user.id}`, {
//                             state: {
//                               isOwnProfile: false,
//                               profileData: user,
//                             },
//                           });
//                         }
//                       }}
//                     >
//                       <img
//                         src={user.profile_picture || admin}
//                         alt={user.name}
//                         className="w-9 h-9 rounded-full object-cover"
//                       />
//                       {user.name}
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//       )}
//     </div>

//     {menuOpen && (
//       <div className="w-full flex justify-between items-center py-1.5 px-0 bg-[#fafafa] border-t border-[#eee] mt-2.5">
//         <Link to="/home" onClick={() => setMenuOpen(false)} className="py-2.5 px-0 text-gray-800 text-base no-underline hover:bg-[#f0f0f0]">
//           Home
//         </Link>
//         <div className="flex gap-4">
//           {["all", "publication", "video", "image", "code", "job", "post"].map((type) => {
//             const currentType =
//               new URLSearchParams(location.search).get("type") || "all";
//             return (
//               <button
//                 key={type}
//                 onClick={() => handleContentFilter(type)}
//                 className={`px-3 py-1.5 text-sm font-medium border border-[#797979] rounded-[var(--radius-md)] cursor-pointer outline-none ${
//                   currentType === type ? "bg-blue-500 text-white" : "bg-white text-[var(--text-primary)]"
//                 }`}
//               >
//                 {type === "all"
//                   ? "All"
//                   : type.charAt(0).toUpperCase() + type.slice(1) + (type === "video" ? "s" : "")}
//               </button>
//             );
//           })}
//         </div>

//         <AddNewDropdown
//           isOpen={openDropdown === "btn1"}
//           onClose={() => setOpenDropdown(null)}
//         />
//       </div>
//     )}
//   </nav>

//   {showDeleteModal && (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
//       <div className="bg-[var(--surface-panel)] p-8 rounded-xl w-[90%] max-w-[400px] text-center animate-fadeIn">
//         <h3 className="mb-4 text-[#d9534f] font-medium">Are you sure you want to delete your account?</h3>
//         <p className="mb-6 text-[0.95rem] text-[#555]">This action cannot be undone.</p>
//         <div className="flex justify-between gap-4">
//           <button
//             className="flex-1 px-4 py-2.5 bg-[#d9534f] text-white font-semibold cursor-pointer transition-colors duration-200 hover:bg-[#c9302c]"
//             onClick={handleConfirmDelete}
//           >
//             Confirm
//           </button>
//           <button
//             className="flex-1 px-4 py-2.5 bg-transparent border border-[#797979] text-[var(--text-primary)] font-semibold cursor-pointer transition-colors duration-200 hover:bg-[#e0e0e0]"
//             onClick={() => setShowDeleteModal(false)}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   )}
// </>
  );
};
export default MobileHeader;
